import { StyleSheet } from "react-native";


/* Styles for the component Main */

const style = StyleSheet.create({
  fontFamily: "Open Sans",

  descriptionContainer: {
    width: "95%",
    textAlign: "center",
    alignSelf: "center",
    fontFamily: "OpenSans",
    fontSize: "2vh",
    // fontWeight: "bold",
    fontFamily: "Gothic",
    // color: "white"
  },
  titlePremi: {
    fontSize: "2.5vh",
    color: "#006fb7",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Gothic",
    fontWeight: "bold",
  },
  textPremi: {
    fontSize: "2vh",
    color: "#006fb7",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Leckerli One",
    // textShadow: "-0.5vh -0.5vh 0.5vh #f2eed7, 0.5vh -0.5vh 0.5vh #f2eed7, -0.5vh 0.5vh 0.5vh #f2eed7, 0.5vh 0.5vh 0.5vh #f2eed7"
  },
  punts: {
    width: "100%",
    textAlign: "center",
    alignSelf: "center",
    fontFamily: "OpenSans",
    fontSize: "2.2vh",
    fontWeight: "bold",
    marginVertical: 5,
    // color: "#3d342a"
  },
});

export default style;
